import Disclaimer from '../components/Disclaimer'
import { Link } from 'react-router-dom'
import Navigation from '../components/Navigation'
import { ROUTES } from '../Routes'
import { usePageTitle } from '../hooks/usePageTitle'

const HowWeRatePage = () => {
    usePageTitle('How We Rate');
    return (
        <div id="body" className="page-template-default page page-id-261 wp-embed-responsive how-we-rate geo-az bid-60">
            <Disclaimer />
            <Navigation />
            <main>
                <section id="intro" className="w-full relative flex items-center min-h-[134px] bg-hero ">
                    <div className="hero my-auto flex flex-row items-center">
                        <div className="z-[1] flex-1 container">
                            <div className="py-[24px] sm:py-[32px]">
                                <h1 className="leading-[40px] text-[34px] sm:leading-[40px] font-semibold text-[#323738] m-0">
                                    How We Rate
                                </h1>
                                <div
                                    className="text-[#323738] mt-[8px] text-[14px] leading-[20px] sm:text-[16px] md:leading-[20px] lg:leading-[24px]">
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className="container">
                    <div className="flex justify-between flex-col lg:flex-row-reverse gap-[24px]">
                        <div id="content-area" className="container legal-page !mt-[20px]">
                            <p>There are dozens of brands offering products and services online, but it can be difficult to
                                filter through
                                the endless information and verify its accuracy. We have created comparison websites to help you
                                compare key
                                elements and features, and make an informed decision. Our goal is to save you time and effort by
                                simplifying
                                and clarifying the decision process, while choosing a service or product that suits your needs.
                            </p>
                            <p>Trying to differentiate between all the available options is not easy. There are brands you might
                                already be
                                familiar with, and that can be a good starting point, but how do you know that the brands
                                shouting the
                                loudest are really the best suited for your needs? There are in fact huge differences between
                                brands,
                                including in the level of service, the terms and conditions, the specific features, and a whole
                                host of
                                other factors.</p>
                            <p>We have a team of reviewers who perform market research, conduct in-depth analyses, aggregate
                                data, and
                                evaluate the information we collect. According to the evaluation, we present the brands that we
                                believe
                                offer high quality products and services.
                                There are quite a few aspects we consider when we review and rate, including our own subjective
                                evaluation
                                and internal methodology. The following is an explanation the review, rating and scoring
                                elements.
                            </p>
                            <h2 id="1">Our Review</h2>
                            <p>The team researches, evaluates, and compares the key features of each brand, product, and service
                                prior to
                                displaying it.
                            </p>

                            <h2 id="2">User’s experience and brands’ reputation</h2>
                            <p>User feedback and experience are important to us, so we take these into consideration when we
                                rate products
                                and services. We also encourage our users to rate, comment, and share their experiences on our
                                site. These
                                reviews and ratings help us understand the popularity and quality of the product.</p>

                            <h2 id="3">Pricing</h2>
                            <p>Where applicable, we will take into consideration the best price for a similar service.</p>

                            <h2 id="4">Features</h2>
                            <p>We evaluate and compare each of the service or product’s features. We look at the features and
                                elements that
                                are common or essential to each product or service type, as well as special features that a
                                brand, product,
                                or service provides.</p>

                            <h2 id="5">Popularity and conversion rates</h2>
                            <p>Data gives us a clear picture of how our users feel about a particular brand. We can measure
                                interest in each
                                product or service by observing the number of users who visit their website, as well as the
                                conversion rate.
                                The conversion rate measures how many people sign up with – or purchase from – a brand after
                                visiting their
                                website. In our rating and scoring we take into consideration the conversion rates because we
                                believe it is
                                an indication of its popularity, and thus, its value. For example, if a specific service’s site
                                is accessed
                                by a significant number of users, or has a significant amount of registered users, we believe it
                                indicates
                                users’ preference and satisfaction.</p>

                            <h2 id="6">Advertising Fees</h2>
                            <p>This website is an informative comparison site that aims to offer its users find helpful
                                information regarding
                                the products and offers that will be suitable for their needs. We are able to maintain a free,
                                high-quality
                                service by receiving advertising fees from the brands and service providers we review on this
                                website
                                (though we may also review brands we are not engaged with). These advertising fees, combined
                                with our criteria
                                and methodology, such as the conversion rates, our team of reviewer's finding and subjective
                                experience and
                                product popularity, impact the placement and position of the brands within the comparison table.
                                In the event
                                rating or scoring are assigned by us, they are based on the position in the comparison table, or
                                according
                                to other formula in the event specifically detailed by us. See our <Link target='_blank'
                                    to={ROUTES.HOW_WE_RATE} className='text-link'>How we Rate</Link>
                                page and <Link className='text-link' target='_blank' to={ROUTES.TERMS_AND_CONDITIONS}>Terms of Use</Link> for
                                information.
                                The reviews, rating and scoring are provided “as-is” without guaranties or warranties regarding
                                the information
                                contained in our website, which shall not be considered as endorsement. We make the best efforts
                                to keep the
                                information
                                up-to-date, however, an offer’s terms might change at any time. We do not compare or include all
                                service
                                providers, brands
                                and offers available in the market.</p>

                            <p className="!font-bold italic">As you’ve probably worked out by now, reviewing and rating different
                                types of products
                                and
                                services is not an exact science. We strive to provide you with the most accurate and
                                comprehensive
                                information to enable you to make an informed and smart decision. However, we would like to
                                remind
                                you that we are solely the provider of this informative website, thus, we encourage you to rely
                                on
                                several sources of information, and specifically, to review each offers’ full terms carefully,
                                to
                                make sure you understand them and that they suit your needs. The full offers’ will be provided
                                by
                                the applicable service provider.
                            </p>
                            <p className="!font-bold italic">The reviews, rating and scoring are provided by us, “as-is”, and we
                                hereby disclaim all
                                expressed
                                guarantees and warrants with regards to the information contained in our website. We make the
                                best
                                efforts to keep the information up-to-date and accurate. However, a service or offer terms might
                                change without our knowledge, and we do not compare or include all service providers on the
                                market.
                                Your use of and reliance on the information displayed in the website is entirely at your own
                                responsibility and risk and we suggest you read our <a href="/terms-and-conditions/">Terms and
                                    Conditions</a>&nbsp;prior to your use.</p>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    )
}

export default HowWeRatePage